import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';


import * as configActions from '../configActions';
import * as configSelectors from '../configSelectors';

import configService from '../../../../services/ConfigService';


function GlobalConfiguration({children}) {

    const isGlobalConfigLoading = useSelector(configSelectors.isGlobalConfigLoading);
    const isGlobalConfigLoaded = useSelector(configSelectors.isGlobalConfigLoaded);
    const dispatch = useDispatch();

    useEffect(() => {

        if (!isGlobalConfigLoaded) {

            if (!isGlobalConfigLoading) {

                dispatch(configActions.onGlobalConfigLoading());

                (async () => {

                    const globalConfig = await configService.loadGlobalConfig();
                    dispatch(configActions.onGlobalConfigLoaded(globalConfig));
                })();
            }
        }
    }, [isGlobalConfigLoaded, isGlobalConfigLoaded]);

    if (!isGlobalConfigLoaded) {

        return null;
    }

    return children;
}


GlobalConfiguration.propTypes = {
    children: PropTypes.any
};


export default GlobalConfiguration;
